import styled from 'styled-components';
import {colors} from '../../../utils/styled/_variables.styled';

export const InfiosInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  span {
    margin-top: 8px;
    color: ${colors.error};
  }
`

export const InfiosInput = styled.input`
  display: flex;
  height: 48px;
  width: 100%;
  padding: 12px 44px 12px 12px;
  border: 1px solid ${colors.infiosGray};
  outline: none;

  &~ label ~ span {
    display: none;
  }

  &.error {
    border: 1px solid ${colors.error};
  }

  &.error ~ label ~ span {
    display: block;
  }

  &:hover {
    border: 2px solid ${colors.blue};
  }

  &:focus {
    border: 2px solid ${colors.blue};
  }

  &:focus ~ label, &:valid ~ label, &.has-value ~ label {
    top: -5px;
    left: 8px;
    font-size: 10px;
    font-weight: 600;
    color: ${colors.infiosGray};
    background-color: #fff;
    padding: 0 5px 0 5px;
  }

  &:disabled {
    background-color: ${colors.gray1};
    border: 1px solid ${colors.gray1};
    pointer-events: none;
  }
`

export const InfiosInputIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${props => ((props.containerHeight / 2) + 19) + "px"};
  right: 13px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;

  &:hover {
    svg {
      path {
        fill: ${colors.blue};
      }
    }

    & ~ input {
      border: 2px solid ${colors.blue};
    }
  }

  svg {
    pointer-events: none;

    path {
      fill: ${props => props.disabled
              ? colors.gray4
              : props.showHideState
                      ? colors.blue
                      : colors.infiosGray};
    }

  }
`
